import React, {useRef, useState} from "react";
import PropTypes from "prop-types";
import {PinCloudPortal} from "./PinCloudPortal";

const Brand = ({ niceName, count, logoUrl, isFranchise }) => {
  return (
    <div className="pin__brand">
      <div className="row align-items-center">
        {isFranchise ? <span className="franchise_icon">F</span> : null }
        <div className="brand_logo"><img src={logoUrl} alt="brand logo"/></div>
        {/*<div className="col d-flex align-items-center">{niceName + (isFranchise ? " (franchise)" : "")}</div>*/}
        <div className="col text-right brand_count">
          <span>{count}</span>
        </div>
      </div>
    </div>
  );
};


const getPartOfMap = (pinNode, mapSelector) => {
  if(pinNode) {
    let offsetTopPin = pinNode.getBoundingClientRect()
    let offsetTopMap = document.querySelector(mapSelector).getBoundingClientRect()
    let heightMapContainer = document.querySelector(mapSelector)
    return offsetTopPin.y - offsetTopMap.y < heightMapContainer.offsetHeight/2
  } else{
    return false
  }
}

const Pin = ({ count, brands }) => {
  const [open, setOpen] = useState(false)
  const [pinIsOnBottom, setPinIsOnBottom] = useState(false)
  const pin = useRef(null);
  return (
    <div className="pin" ref={pin}>
      {open ? (
        <PinCloudPortal>
          <div className="pin__cloud">
            <a className="pin__cloud-close" onClick={() => setOpen(false)}><i className="fas fa-times"></i></a>
            <div className="pin__cloud-pins">

            {brands.map((brand, key) => (
              <div key={'pcw' + key}>
                <Brand {...brand} key={key}/>
              </div>
            ))}
        </div>
          </div>
        </PinCloudPortal>
      ) : null}
      <div
        className="pin__marker"
        onClick={() => (open ? setOpen(false) : setOpen(true))}
      >
        <div>{count}</div>
      </div>
    </div>
  );
};
Pin.propTypes = {
  count: PropTypes.number.isRequired
};

export default Pin;
